import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

declare var DBSService_BASE_URL: string;

// ============================================
// Interfaces
// ============================================

export interface ProcessTemplate {
  id?: number;
  name: string;
  description: string;
  taskTemplates?: TaskTemplate[];
}

export interface TaskTemplate {
  id?: number;
  process_Id: number;
  parentProcess_Id?: number | null;
  sequence: number;
  isParallel: boolean;
  template_Id: number;
  isRequired: boolean;
  // Included nav objects
  process?: { id: number; name: string };
  template?: { id: number; name: string; description: string };
  // Display helpers
  processName?: string;
  templateName?: string;
}

// ============================================
// Service
// ============================================

@Injectable({
  providedIn: 'root'
})
export class ProcessTemplateService {
  private get baseUrl(): string {
    return `${DBSService_BASE_URL}/api/ProcessTemplate`;
  }

  constructor(private http: HttpClient) {}

  // ---- ProcessTemplate ----

  getProcessTemplates(): Observable<ProcessTemplate[]> {
    return this.http.get<ProcessTemplate[]>(`${this.baseUrl}`);
  }

  getProcessTemplate(id: number): Observable<ProcessTemplate> {
    return this.http.get<ProcessTemplate>(`${this.baseUrl}/${id}`);
  }

  createProcessTemplate(template: ProcessTemplate): Observable<ProcessTemplate> {
    return this.http.post<ProcessTemplate>(`${this.baseUrl}`, template);
  }

  updateProcessTemplate(id: number, template: ProcessTemplate): Observable<ProcessTemplate> {
    return this.http.put<ProcessTemplate>(`${this.baseUrl}/${id}`, template);
  }

  deleteProcessTemplate(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  // ---- TaskTemplate ----

  getTaskTemplates(processTemplateId: number): Observable<TaskTemplate[]> {
    return this.http.get<TaskTemplate[]>(`${this.baseUrl}/${processTemplateId}/tasks`);
  }

  createTaskTemplate(processTemplateId: number, task: TaskTemplate): Observable<TaskTemplate> {
    return this.http.post<TaskTemplate>(`${this.baseUrl}/${processTemplateId}/tasks`, task);
  }

  updateTaskTemplate(processTemplateId: number, taskId: number, task: TaskTemplate): Observable<TaskTemplate> {
    return this.http.put<TaskTemplate>(`${this.baseUrl}/${processTemplateId}/tasks/${taskId}`, task);
  }

  deleteTaskTemplate(processTemplateId: number, taskId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${processTemplateId}/tasks/${taskId}`);
  }

  reorderTaskTemplates(processTemplateId: number, taskIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${processTemplateId}/tasks/reorder`, { taskIds });
  }
}
